export default __webpack_public_path__ + "static/media/Vambraces of the Wicked.8c975b53.jpg";